import { AiOutlineHome } from "react-icons/ai";
import { RiProfileFill, RiProfileLine, RiProgress6Line } from "react-icons/ri";
import { AiFillHome } from "react-icons/ai";
import { RiProgress6Fill } from "react-icons/ri";
import { RiFileCheckFill } from "react-icons/ri";
import { RiFileCheckLine } from "react-icons/ri";
import { PiSignature, PiSignatureFill, PiUsersThreeFill } from "react-icons/pi";
import {
  BsEnvelope,
  BsEnvelopeOpen,
  BsFileEarmarkArrowUp,
  BsMailbox,
  BsMailbox2,
} from "react-icons/bs";
import { BsFileEarmarkArrowUpFill } from "react-icons/bs";
import { PiUsersThreeBold } from "react-icons/pi";

export const SidebarLinks = [
  {
    title: "Почетна",
    icon: <AiOutlineHome />,
    selectedIcon: <AiFillHome />,
    path: "/",
    roles: [
      "ROLE_MVR_ADMINISTRATOR",
      "ROLE_JPDP_ADMINISTRATOR",
      "ROLE_SUPER_ADMIN",
      "ROLE_APPLICANT",
      "ROLE_ADMINISTRATOR",
      "ROLE_MT_ARCHIVER",
      "ROLE_MT_REVIEWER",
      "ROLE_MT_SUPERVISOR",
      "ROLE_MT_SIGNER",
      "ROLE_MVR_RECEIVER",
      "ROLE_MVR_REVIEWER",
      "ROLE_MVR_SIGNER",
      "ROLE_JPDP_RECEIVER",
      "ROLE_JPDP_REVIEWER",
      "ROLE_JPDP_SIGNER",
    ],
  },
  {
    title: "Мој профил",
    icon: <RiProfileLine />,
    selectedIcon: <RiProfileFill />,
    path: "/profile",
    roles: [
      "ROLE_MVR_ADMINISTRATOR",
      "ROLE_JPDP_ADMINISTRATOR",
      "ROLE_SUPER_ADMIN",
      "ROLE_ADMINISTRATOR",
      "ROLE_MT_ARCHIVER",
      "ROLE_MT_REVIEWER",
      "ROLE_MT_SUPERVISOR",
      "ROLE_MT_SIGNER",
      "ROLE_MVR_RECEIVER",
      "ROLE_MVR_REVIEWER",
      "ROLE_MVR_SIGNER",
      "ROLE_JPDP_RECEIVER",
      "ROLE_JPDP_REVIEWER",
      "ROLE_JPDP_SIGNER",
    ],
  },
  {
    title: "Корисници",
    icon: <PiUsersThreeBold />,
    selectedIcon: <PiUsersThreeFill />,
    path: "/users",
    roles: [
      "ROLE_ADMINISTRATOR",
      "ROLE_MVR_ADMINISTRATOR",
      "ROLE_JPDP_ADMINISTRATOR",
      "ROLE_SUPER_ADMIN",
    ],
  },
  {
    title: "Аудит настани",
    icon: <RiProgress6Line />,
    selectedIcon: <RiProgress6Fill />,
    path: "/auditEventsLog",
    roles: ["ROLE_SUPER_ADMIN"],
  },
  {
    title: "Меил лог",
    icon: <BsEnvelope />,
    selectedIcon: <BsEnvelopeOpen />,
    path: "/mailLog",
    roles: ["ROLE_SUPER_ADMIN"],
  },
  {
    title: "Барања",
    icon: <BsFileEarmarkArrowUp />,
    selectedIcon: <BsFileEarmarkArrowUpFill />,
    path: "/entries/progress",
    roles: ["ROLE_MT_ARCHIVER", "ROLE_MT_REVIEWER", "ROLE_MT_SUPERVISOR"],
  },
  {
    title: "Завршени барања",
    icon: <RiFileCheckLine />,
    selectedIcon: <RiFileCheckFill />,
    path: "/entries/completed",
    roles: ["ROLE_MT_ARCHIVER", "ROLE_MT_REVIEWER", "ROLE_MT_SUPERVISOR"],
  },
  {
    title: "Мои барања",
    icon: <BsMailbox />,
    selectedIcon: <BsMailbox2 />,
    path: "/reviews/assigned",
    roles: ["ROLE_MVR_REVIEWER", "ROLE_JPDP_REVIEWER"],
    taskCountProperty: "assignedToUser",
  },
  {
    title: "Сите барања",
    icon: <BsFileEarmarkArrowUp />,
    selectedIcon: <BsFileEarmarkArrowUpFill />,
    path: "/reviews/active",
    roles: [
      "ROLE_MVR_REVIEWER",
      "ROLE_MVR_SIGNER",
      "ROLE_JPDP_REVIEWER",
      "ROLE_JPDP_SIGNER",
    ],
  },
  {
    title: "Барања за архивирање",
    icon: <BsFileEarmarkArrowUp />,
    selectedIcon: <BsFileEarmarkArrowUpFill />,
    path: "/reviews/archiving",
    roles: [
      "ROLE_MVR_RECEIVER",
      "ROLE_MVR_SIGNER",
      "ROLE_JPDP_RECEIVER",
      "ROLE_JPDP_SIGNER",
    ],
    taskCountProperty: "forArchiving",
  },
  {
    title: "За распределба",
    icon: <BsFileEarmarkArrowUp />,
    selectedIcon: <BsFileEarmarkArrowUpFill />,
    path: "/reviews/assignment",
    roles: ["ROLE_MVR_SIGNER", "ROLE_JPDP_SIGNER"],
    taskCountProperty: "forAssigning",
  },
  {
    title: "За потпис",
    icon: <PiSignature />,
    selectedIcon: <PiSignatureFill />,
    path: "/reviews/forsigning",
    roles: ["ROLE_JPDP_SIGNER", "ROLE_MVR_SIGNER"],
    taskCountProperty: "forSigning",
  },
  {
    title: "Завршени барања",
    icon: <RiFileCheckLine />,
    selectedIcon: <RiFileCheckFill />,
    path: "/reviews/completed",
    roles: [
      "ROLE_MVR_RECEIVER",
      "ROLE_MVR_REVIEWER",
      "ROLE_MVR_SIGNER",
      "ROLE_JPDP_RECEIVER",
      "ROLE_JPDP_REVIEWER",
      "ROLE_JPDP_SIGNER",
    ],
  },
];
